import { ListItemChangeEventDetail } from '@wppopen/components-library'
import { WppListItem, WppCheckbox, WppSelect } from '@wppopen/components-library-react'
import { Dispatch, SetStateAction, useCallback, useMemo } from 'react'
import {
  FilterReducerAction,
  IdValuePair,
  InputFilterComponentData,
} from 'reducers/GenericFiltersReducer/GenericFiltersReducer.d'
import styles from './Filters.module.scss'
import FilterInput from './FilterInput'

interface FilterSelectInputComboProps {
  groupInputKeys: IdValuePair[]
  isLoading: boolean
  reducerDispatch: Dispatch<FilterReducerAction>
  inputObject: InputFilterComponentData
  activeSearchElementKey: string
  setActiveSearchElementKey: Dispatch<SetStateAction<string>>
}

const FilterSelectInputCombo = ({
  groupInputKeys,
  isLoading,
  inputObject,
  reducerDispatch,
  activeSearchElementKey,
  setActiveSearchElementKey,
}: FilterSelectInputComboProps) => {
  const handleOptionClick = useCallback((event: CustomEvent<ListItemChangeEventDetail>) => {
    event.preventDefault()
    const { value } = event.target as HTMLWppListItemElement
    const { id } = value as IdValuePair
    setActiveSearchElementKey(id)
  }, [])

  const inputSelectOptions = useMemo(() => {
    return groupInputKeys.map(option => {
      const isChecked = option.id === activeSearchElementKey
      return (
        <WppListItem
          value={option}
          key={option.id}
          onWppChangeListItem={handleOptionClick}
          data-testid={`${option.value}-li`}
          disabled={isLoading}
          checked={isChecked}
        >
          <WppCheckbox checked={isChecked} slot="left" data-testid={`${option}-li-checkbox`} />
          <span slot="label" className={styles.filter__liTextContent} data-testid={`${option}-li-span`}>
            {option.value}
          </span>
        </WppListItem>
      )
    })
  }, [activeSearchElementKey, groupInputKeys, handleOptionClick, isLoading])

  const groupedInputObject = useMemo(() => {
    return (
      inputObject && (
        <FilterInput
          filterObject={inputObject}
          reducerDispatch={reducerDispatch}
          isLoading={isLoading}
          key={activeSearchElementKey}
          isGroupItem={true}
          className={styles.selectInputCombo__input}
        />
      )
    )
  }, [inputObject, reducerDispatch, isLoading, activeSearchElementKey])

  return (
    // wrapper div required for justified styling of the filter row components
    <div>
      <div className={styles.selectInputCombo__container}>
        <WppSelect
          name="input-select"
          required
          value={groupInputKeys.find(key => key.id === activeSearchElementKey)}
          maxItemsToDisplay={4}
          data-testid="input-select"
          type="single"
          showSelectAllText={false}
          className={styles.selectInputCombo__select}
        >
          {inputSelectOptions}
        </WppSelect>
        {groupedInputObject}
      </div>
    </div>
  )
}

export default FilterSelectInputCombo
